import React, { Component } from 'react';

class ResultSidebar extends Component {
	render() {
		return (
			<div className="result__sidebar">
				<h1 className="result__sidebar--heading">Hassle-free personalised routine that works for you</h1>
				<div className="result__sidebar--checkout">
					<p><em>Yours Mini Personalised set- <span className="float-right">$15</span></em></p>
					<ul>
						<li>1 Day Cream</li>
						<li>1 Night Cream</li>
						<li>1 Day Serum</li>
						<li>1 Night Serum</li>
						<li>1 Exfoliating pads</li>
					</ul>
					<hr />
					<p><em>Sub Total <span className="float-right">$15</span></em></p>
					<p><em>Shipping (1 - 2 Weeks) <span className="float-right">$15</span></em></p>
					<hr />
					<h3>Total <span className="float-right">$15</span></h3>
				</div>
				<button type="button" class="btn btn-primary try__now">TRY NOW - $15</button>
				<p className="text-center m-0 mb-1"><img src="/images/get-back.svg" /> <strong>Get back $15 on upgrading to</strong> Full Set</p>
				<p className="text-center m-0"><img src="/images/ship-truck.svg" /> <strong>Free</strong> Shipping</p>
			</div>
		);
	}
}


export default ResultSidebar;